import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Snapshot } from 'types';

export const deleteSnapshot = (snapshotId: number) => {
  return axios.delete(`/api/snapshots/${snapshotId}`);
};

type UseDeleteSnapshotOptions = {
  analyzerId: number;
  config?: MutationConfig<typeof deleteSnapshot>;
};

export const useDeleteSnapshot = ({
  analyzerId,
  config,
}: UseDeleteSnapshotOptions) => {
  return useMutation({
    onMutate: async (deletedSnapshotId: number) => {
      await queryClient.cancelQueries(['snapshots', analyzerId]);

      const previousSnapshots = queryClient.getQueryData<Snapshot[]>([
        'snapshots',
        analyzerId,
      ]);

      queryClient.setQueryData(
        ['snapshots', analyzerId],
        previousSnapshots?.filter(
          (snapshot) => snapshot.id !== deletedSnapshotId
        )
      );

      return { previousSnapshots };
    },
    onError: (_, __, context: any) => {
      if (context?.previousAnalyzers) {
        queryClient.setQueryData(
          ['snapshots', analyzerId],
          context.previousSnapshots
        );
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshots', analyzerId]);
      queryClient.invalidateQueries(['snapshots', 'list']);
    },
    ...config,
    mutationFn: deleteSnapshot,
  });
};
